import React from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";

const MapDrag = ({
  onMarkerDragEnd,
  markerPosition,
  onPlaceSelected,
  autocompleteRef,
}) => {
  const mapStyles = {
    height: "400px",
    width: "100%",
  };

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_MAP_KEY}
      libraries={["places"]}
    >
      <GoogleMap
        mapContainerStyle={mapStyles}
        zoom={14}
        center={markerPosition}
      >
        <Marker
          position={markerPosition}
          draggable={true}
          onDragEnd={(e) => onMarkerDragEnd(e.latLng)}
        />

        <Autocomplete
          onLoad={(autocomplete) => {
            autocompleteRef.current = autocomplete;
          }}
          onPlaceChanged={() => onPlaceSelected()}
        >
          <input
            id="autocomplete"
            type="text"
            placeholder="Search places..."
            className="box-border border-2 border-transparent w-60 ml-6 h-4 px-2 rounded-md shadow-md text-base outline-none overflow-ellipsis absolute left-1/2 transform -translate-x-1/2 top-1"
          />
        </Autocomplete>
      </GoogleMap>
    </LoadScript>
  );
};
export default MapDrag;
